





















import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    Component,
    Vue,
    Prop,
    Watch
} from "vue-property-decorator";
import {
    componentDataType
} from "../types";
import {
    pageDataType
} from "../types";
import {
    HOST,
    API_URL
} from "../global";
import axios from "axios";

@Component({
    name: "GlobalMap",
    components: {

    }

})
export default class GlobalMap extends Vue {
    @Prop() public compData!: string | null;
    public HOST: string = HOST;
    settingdata: any[] = [];
    infoWindowPos: null = null;
    infoContent: any = "";
    infoOpened: boolean = false;
    infoCurrentKey: null = null;
    infoOptions:any = {
                pixelOffset: {
                    width: 0,
                    height: -35
                }
            }
   
    toggleInfo(pos: any, index: any) {
        this.infoWindowPos = this.preparePosition(pos.position);
       // console.log(this.preparePosition(pos));
        this.infoContent = pos.label;
        if (this.infoCurrentKey == index) {
            this.infoOpened = !this.infoOpened;
        } else {
            this.infoOpened = true;
            this.infoCurrentKey = index;
        }
    }
    preparePosition(pos: any): any {
        return {
            lat: parseFloat(pos.lat),
            lng: parseFloat(pos.lng)
        }
    }

    created() {

        axios.get(`${API_URL}/others/settings/global-settings/`)
            .then(response => {
                (this as any).settingdata = response.data
            })
            .catch(e => {
                (this as any).errors.push(e)
            })

    }

}
